import * as capTransport from './transport_capacitor';
import * as webTransport from './transport_web_bluetooth';

export * from './render';
export { POS_SUPPORTED_PRINTERS } from './allowlist';

function isCapacitorEnv(): boolean {
  return typeof window !== 'undefined' && ('Capacitor' in window || 'cordova' in window);
}

const transport = isCapacitorEnv() ? capTransport : webTransport;

export const pairPrinter = transport.pairPrinter;
export const unpairPrinter = transport.unpairPrinter;
export const getPairedPrinter = transport.getPairedPrinter;
export const printBytes = transport.printBytes;
export const kickDrawer = transport.kickDrawer;
